import * as React from 'react'

function SvgScratchSmallIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M11.992 10c-2.389 0-4.786.326-7.887.989a.5.5 0 1 1-.21-.978C7.035 9.34 9.508 9 11.994 9c2.485 0 4.963.34 8.111 1.011a.5.5 0 1 1-.208.978c-3.112-.662-5.514-.989-7.904-.989ZM4.105 14.989c3.101-.663 5.498-.99 7.887-.989 2.39 0 4.792.327 7.904.989a.5.5 0 1 0 .208-.978c-3.148-.67-5.626-1.01-8.111-1.011-2.486 0-4.959.34-8.097 1.011a.5.5 0 1 0 .209.978Z"
        fill="#F16B0A"
      />
    </svg>
  )
}

export default SvgScratchSmallIcon
